import { render, staticRenderFns } from "./WallSpeakersBlockSettings.vue?vue&type=template&id=93d8abd6"
import script from "./WallSpeakersBlockSettings.vue?vue&type=script&lang=js"
export * from "./WallSpeakersBlockSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports